// src/components/LineChartTrends.js
import React, { useEffect, useState } from "react";
import { Line } from "@ant-design/charts";
import axios from "axios";
import dayjs from "dayjs";

const LineChartTrends = () => {
  const [chartData, setChartData] = useState([]);
  const [loading, setLoading] = useState(true);

  const groupByMonth = (crises) => {
    const counts = {};

    crises.forEach((item) => {
      const month = dayjs(item.date, "M/D/YYYY").format("MMM");
      counts[month] = (counts[month] || 0) + 1;
    });

    const sortedMonths = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const result = sortedMonths.map((m) => ({
      month: m,
      value: counts[m] || 0,
      type: "Cases",
    }));

    // Optionally simulate "Prediction" series
    const prediction = result.map((item) => ({
      month: item.month,
      value: Math.round(item.value * 0.75 + 50), // simple mock prediction
      type: "Prediction",
    }));

    return [...result, ...prediction];
  };

  useEffect(() => {
    const fetchCrises = async () => {
      try {
        const res = await axios.get("https://node-api-dot-crisisvision-ai-backend.uc.r.appspot.com/api/crises");
        const grouped = groupByMonth(res.data);
        setChartData(grouped);
        setLoading(false);
      } catch (error) {
        console.error("Failed to fetch crisis data:", error);
        setLoading(false);
      }
    };

    fetchCrises();
  }, []);

  const config = {
    data: chartData,
    xField: "month",
    yField: "value",
    seriesField: "type",
    smooth: true,
    height: 400,
    color: ({ type }) => (type === "Cases" ? "#1890ff" : "#f5222d"),
    point: {
      size: 4,
      shape: "circle",
      style: {
        fill: "white",
        stroke: "#5B8FF9",
        lineWidth: 2,
      },
    },
    tooltip: { showMarkers: true },
    legend: { position: "top" },
  };

  if (loading) return <p>Loading wildfire trends...</p>;

  return (
    <div
      style={{
        backgroundColor: "#fff",
        padding: "1.5rem",
        borderRadius: "12px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
      }}
    >
      <h3 style={{ marginBottom: "1rem" }}>📈 Wildfire Trends Over Time</h3>
      <Line {...config} />
    </div>
  );
};

export default LineChartTrends;
